/*LIBRARY*/
import { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

/*COMPONENT*/
import Modal from "../common_modal/Modal";

/*REDUX*/
import {
  post_feedback,
  get_feedback_list_by_user,
} from "../../App/actions/activities";
import { set_value_properties } from "../../App/actions/propertiesActions"; // Imported properly for Redux sync
import useLanguage from "../common_hooks/useLanguage";

/*PICTURE*/

/*FUNCTION*/

/*DATA*/

/*CONST*/

const FEEDBACK = ({ showFeedback, setShowFeedback }) => {
  const loading_reducer = useSelector((state) => state.loading_reducer);
  const { loading_item_array } = loading_reducer;

  const properties = useSelector((state) => state.properties);
  const { feedback_list } = properties;

  const [view, setView] = useState("input"); // 'input', 'success', 'history'
  const [feedback_text, setFeedbackText] = useState("");
  const [feedback_topic, setSelectedTopic] = useState("");
  const [showWarningModal, setShowWarningModal] = useState(false);
  const feedbackTextareaRef = useRef(null);

  const { dict, language } = useLanguage();

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(get_feedback_list_by_user());
  }, [dispatch]);

  useEffect(() => {
    if (!showFeedback) {
      setView("input");
    }
  }, [showFeedback]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape" && showFeedback) {
        setShowFeedback(false);
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [showFeedback, setShowFeedback]);

  const handle_submit_feedback = () => {
    // Check if feedback text or topic is empty
    if (!feedback_topic || !feedback_text.trim()) {
      setShowWarningModal(true);
      return;
    }

    console.log("Submitting feedback:", {
      feedback_topic: feedback_topic,
      feedback_text: feedback_text,
    });

    const body = {
      feedback_text,
      feedback_topic,
      action: "feedback",
    };
    dispatch(post_feedback(body));

    setFeedbackText("");
    setSelectedTopic("");
    setView("success");
  };

  const handle_hide_feedback_button = () => {
    // 1. Set standard browser storage
    localStorage.setItem("is_show_feedback_button", "false");
    // 2. Dispatch updated parameter directly to properties redux store
    dispatch(
      set_value_properties({ key: "is_show_feedback_button", value: false }),
    );
    // 3. Immediately close feedback UI
    setShowFeedback(false);
  };

  const toggle_warning_modal = () => {
    setShowWarningModal((prev) => !prev);
  };

  const topic_list = [
    {
      value: "site_selection",
      ina: "Site Selection",
      eng: "Site Selection",
    },
    {
      value: "site_analysis",
      ina: "Site Analysis",
      eng: "Site Analysis",
    },
    {
      value: "toolbox",
      ina: "Tool GIS",
      eng: "GIS Tool",
    },
    {
      value: "import_data",
      ina: "Impor Data",
      eng: "Import Data",
    },
    {
      value: "maps",
      ina: "Peta",
      eng: "Maps",
    },
    {
      value: "ux",
      ina: "Perbaikan UX",
      eng: "UX Improvement",
    },
    {
      value: "other",
      ina: "Lainnya",
      eng: "Other",
    },
  ];

  // Helper function to get the readable Indonesian label for topics
  const getTopicLabel = (topicValue) => {
    const topic = topic_list.find((t) => t.value === topicValue);
    return topic ? topic.ina : topicValue;
  };

  const isFormIncomplete = !feedback_topic || !feedback_text.trim();

  const modal_warning_content = showWarningModal && (
    <Modal
      modalSize="small"
      isOpen={showWarningModal}
      onClose={toggle_warning_modal}
      title="Peringatan"
    >
      <div className="box-body" id="box-body">
        <div className="text_bold margin_bottom_extra">
          {
            dict[
              "Please complete the topic and text of your feedback before sending."
            ][language]
          }
        </div>
        <button
          className="button background_black"
          onClick={toggle_warning_modal}
        >
          {dict["Close"][language]}
        </button>
      </div>
    </Modal>
  );

  const input_content = (
    <>
      <section className="two_container_auto margin_bottom">
        <section>
          <p className="text_big text_left">{`${dict["Hello"][language]} 👋`}</p>
        </section>
        <section className="text_right">
          <button
            className="button hover_primary"
            onClick={() => setView("history")}
            tabIndex={showFeedback ? 0 : -1}
          >
            {dict["Feedback history"][language]}
          </button>
        </section>
      </section>

      <p className="text_bold margin_bottom margin_bottom_extra">
        {
          dict["Help us become better, report user issues or missing data"][
            language
          ]
        }
      </p>

      <section className="container background_grey_light margin_bottom">
        <p className="text_medium sub_color margin_bottom">
          {dict["Choose topic"][language]}
        </p>
        <div className="feedback_topics_wrapper">
          {topic_list.map((topic) => (
            <button
              key={topic.value}
              className={`button_pill_small outline_grey margin_right margin_bottom ${
                feedback_topic === topic.value
                  ? "background_black"
                  : "hover_primary"
              }`}
              onClick={() => setSelectedTopic(topic.value)}
              tabIndex={showFeedback ? 0 : -1}
            >
              {topic?.[language]}
            </button>
          ))}
        </div>
      </section>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          flexGrow: 1,
          marginBottom: "1rem",
        }}
      >
        <textarea
          ref={feedbackTextareaRef}
          className="background_grey_light feedback_textarea"
          placeholder={dict["Write your feedback here"][language]}
          value={feedback_text}
          maxLength={200}
          onChange={(e) => setFeedbackText(e.target.value)}
          tabIndex={showFeedback ? 0 : -1}
          style={{ marginBottom: "4px" }}
        />
        <div className="text_small sub_color text_left">
          {feedback_text.length}/200
        </div>
      </div>

      <div
        className="feedback_actions"
        style={{ alignItems: "center", justifyContent: "space-between" }}
      >
        <button
          className="button_text sub_color"
          style={{
            textDecoration: "underline",
            fontSize: "12px",
            background: "none",
            border: "none",
            cursor: "pointer",
            padding: 0,
          }}
          onClick={handle_hide_feedback_button}
          tabIndex={showFeedback ? 0 : -1}
        >
          {dict["Hide feedback button"][language]}
        </button>

        {loading_item_array.includes("post_feedback") ? (
          <button
            className="button_big background_grey"
            tabIndex={showFeedback ? 0 : -1}
          >
            {dict["Sending....."][language]}
          </button>
        ) : (
          <button
            className={`button_big ${isFormIncomplete ? "background_grey" : "background_black"}`}
            style={{
              opacity: isFormIncomplete ? 0.6 : 1,
              cursor: isFormIncomplete ? "not-allowed" : "pointer",
            }}
            onClick={handle_submit_feedback}
            tabIndex={showFeedback ? 0 : -1}
          >
            {dict["Send"][language]}
          </button>
        )}
      </div>
    </>
  );

  const success_content = (
    <>
      <p className="text_bold margin_bottom margin_bottom_extra">
        {`${dict["Thank you"][language]} 🙏`}
        <br />
        <br />
        {dict["Your feedback has been sent"][language]}
      </p>
      <div className="feedback_actions">
        <button
          className="button background_black outline_grey"
          onClick={() => setView("input")}
          tabIndex={showFeedback ? 0 : -1}
        >
          {dict["Back"][language]}
        </button>
      </div>
    </>
  );

  const feedback_list_content = (
    <>
      <section className="two_container_auto margin_bottom">
        <section>
          <p className="text_bold">{dict["Your feedback history"][language]}</p>
        </section>
        <section className="text_right">
          <button
            className="button outline_grey hover_primary"
            onClick={() => setView("input")}
            tabIndex={showFeedback ? 0 : -1}
          >
            {dict["Back"][language]}
          </button>
        </section>
      </section>

      <div
        className="feedback_history_list margin_bottom_extra"
        style={{ overflowY: "auto" }}
      >
        {loading_item_array.includes("get_feedback_list_by_user") ? (
          <p className="text_center sub_color margin_top">
            {dict["Loading history..."][language]}
          </p>
        ) : feedback_list && feedback_list.length > 0 ? (
          feedback_list.map((item, index) => (
            <div
              key={item._id?.$oid || index}
              className="container background_grey_light margin_bottom"
            >
              <div className="two_container_flex margin_bottom">
                <p className="badge_small background_dark_blue">
                  {getTopicLabel(item.feedback_topic)}
                </p>
                <p className="text_small sub_color text_right">
                  {new Date(item.timestamp).toLocaleDateString("id-ID", {
                    day: "numeric",
                    month: "short",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                  })}
                </p>
              </div>
              <p className="container background_white text_medium sub_color">
                {item.feedback_text}
              </p>
            </div>
          ))
        ) : (
          <p className="text_center sub_color margin_top">
            {dict["No feedback history."][language]}
          </p>
        )}
      </div>
    </>
  );

  return (
    <>
      {modal_warning_content}
      <div
        className={`feedback_container ${
          showFeedback ? "feedback_open" : "feedback_closed"
        }`}
        role="dialog"
        aria-modal="true"
        aria-label="Masukan & Saran"
        aria-hidden={!showFeedback}
      >
        <div className="feedback_blur_header">
          <div className="feedback_blur_title">
            {view === "history"
              ? dict["Feedback history"][language]
              : dict["Write feedback"][language]}
          </div>
          <button
            className="feedback_close_btn"
            onClick={() => setShowFeedback(false)}
            aria-label="Tutup"
            tabIndex={showFeedback ? 0 : -1}
          >
            ✕
          </button>
        </div>

        <div className="feedback_inner">
          {view === "input" && input_content}
          {view === "success" && success_content}
          {view === "history" && feedback_list_content}
        </div>
      </div>
    </>
  );
};

export default FEEDBACK;
